import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BrandingContext = createContext();

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error("useBranding must be used within BrandingProvider");
  }
  return context;
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({
    collegeName: "Expertaid LMS",
    collegeLogo: null,
    collegeCode: "",
    loading: true
  });

  useEffect(() => {
    fetchBranding();
  }, []);

  const fetchBranding = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setBranding(prev => ({ ...prev, loading: false }));
        return;
      }

      const response = await axios.get(`${API}/institutes/logo`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setBranding({
        collegeName: response.data.school_name || "Expertaid LMS",
        collegeLogo: response.data.logo_url || null,
        collegeCode: response.data.school_code || "",
        loading: false
      });
    } catch (error) {
      console.error("Error fetching branding:", error);
      setBranding({
        collegeName: "Expertaid LMS",
        collegeLogo: null,
        collegeCode: "",
        loading: false
      });
    }
  };

  const updateBranding = (updates) => {
    setBranding(prev => ({ ...prev, ...updates }));
  };

  return (
    <BrandingContext.Provider value={{ branding, updateBranding, refetchBranding: fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};
